"use strict";var e=require("./index-f554a4d7.js");require("prop-types"),require("react"),module.exports=e.Editor;
